import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=87b890fa&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=87b890fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b890fa",
  null
  
)

export default component.exports